import React from 'react'
import styled from 'styled-components'

import { BorderedDiv } from 'elements/layout/BorderedDiv'
import { Cell } from 'elements/layout/Cell'
import { Container } from 'elements/layout/Container'
import { Div } from 'elements/layout/Div'
import { PreloadDiv } from 'elements/layout/PreloadDiv'
import { RoundDiv } from 'elements/layout/RoundDiv'
import { Row } from 'elements/layout/Row'
import { StretchCell } from 'elements/layout/StretchCell'

const StyledPreloadDiv = styled(PreloadDiv)`
  max-width: 100%;
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.3);
  border-radius: 5px;
`

export const PreloadPublicationPage: TFC = () => (
  <>
    {/* header */}
    <Container maxW="680px" p={{ xs: '5px 5px 0', sm: '30px 10px 0' }}>
      <Div m={{ xs: '0 30px 0 0', sm: '0 35px 0 0' }}>
        <Row align="middleLeft" gutter="10px" nowrap>
          <Cell>
            <PreloadDiv as={RoundDiv} size="60px" />
          </Cell>
          <StretchCell flex="1">
            <PreloadDiv h="40px" />
            <PreloadDiv w={{ xs: '200px', sm: '300px' }} h="1em" />
          </StretchCell>
        </Row>
      </Div>
    </Container>
    {/* title */}
    <Container p={{ xs: '5px 5px 0', sm: '30px 10px 0' }}>
      <PreloadDiv
        h={{ xs: '25px', sm: '32px', md: '40px' }}
        m={{ xs: '10px 0 1em', sm: '1em 0 20px', md: '1em 0 24px' }}
      />
      <PreloadDiv w="50%" h={{ xs: '25px', sm: '32px', md: '40px', lg: '0px' }} m={{ xs: '0 0 1em', sm: '0 0 23px' }} />
    </Container>
    <Container maxW="680px" p="0px 0 10px">
      {/* image */}
      <StyledPreloadDiv m="0 auto 2em" h="360px" w="680px" maxW="100%" />
      {/* content */}
      <Div p={{ xs: '0 1em 1em', md: '0px' }}>
        {[...Array(20)].map((e, i) => (
          <PreloadDiv key={i} h="20px" m="0 0 5px" w="100%" />
        ))}
        <PreloadDiv h="20px" m="0 0 5px" w="50%" />
        {/* button */}
        <Div p="1em">
          <PreloadDiv m="auto" as={BorderedDiv} h="40px" w="120px" borderRadius="25px" />
        </Div>
      </Div>
    </Container>
  </>
)
